import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
export function filterVAutocomplete(item, queryText, itemText) {
  return String.removeDiacritics(queryText).toLowerCase().split(" ").every(function (x) {
    return String.removeDiacritics(itemText).toLowerCase().includes(x);
  });
}
export var ERROR_DATA = {
  ref: "dialogErrorModalRef",
  DIALOG_TYPES: {
    DIALOG_RELOAD: {
      id: "dialogReload",
      defaultCustomMessage: "An unexpected error occurred. Please reload the page to try again in a few moments."
    },
    DIALOG_WARNING: {
      id: "dialogWarning"
    }
  },
  TOASTER_TYPES: {
    ERROR: {
      id: "error",
      class: "error",
      defaultMessage: "An error occurred. Please contact an administrator.",
      messageIfCompleteExceptionConsole: "An unexpected error occurred"
    },
    WARNING: {
      id: "warning",
      class: "warning"
    },
    INFO: {
      id: "info",
      class: "info"
    }
  }
};
export function getErrorData(e) {
  var _e$response, _managedExceptions$ER, _managedExceptions$ER2, _managedExceptions$ER3, _managedExceptions$ER4, _e$response5, _message;
  var managedExceptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isPriorityToApiMessage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var code = e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 || (_e$response = _e$response.value) === null || _e$response === void 0 ? void 0 : _e$response.errorCode;
  var hasManagedExceptions = !!code && !!managedExceptions;
  var message = "";
  var type = "";
  var dialogType = null;
  if (hasManagedExceptions && typeof ((_managedExceptions$ER = managedExceptions[ERROR_DATA.DIALOG_TYPES.DIALOG_RELOAD.id]) === null || _managedExceptions$ER === void 0 ? void 0 : _managedExceptions$ER[code]) !== "undefined") {
    message = managedExceptions[ERROR_DATA.DIALOG_TYPES.DIALOG_RELOAD.id][code];
    dialogType = ERROR_DATA.DIALOG_TYPES.DIALOG_RELOAD.id;
  } else if (hasManagedExceptions && !!((_managedExceptions$ER2 = managedExceptions[ERROR_DATA.TOASTER_TYPES.ERROR.id]) !== null && _managedExceptions$ER2 !== void 0 && _managedExceptions$ER2[code])) {
    message = managedExceptions[ERROR_DATA.TOASTER_TYPES.ERROR.id][code];
    type = ERROR_DATA.TOASTER_TYPES.ERROR.class;
  } else if (hasManagedExceptions && !!((_managedExceptions$ER3 = managedExceptions[ERROR_DATA.TOASTER_TYPES.WARNING.id]) !== null && _managedExceptions$ER3 !== void 0 && _managedExceptions$ER3[code])) {
    message = managedExceptions[ERROR_DATA.TOASTER_TYPES.WARNING.id][code];
    type = ERROR_DATA.TOASTER_TYPES.WARNING.class;
  } else if (hasManagedExceptions && !!((_managedExceptions$ER4 = managedExceptions[ERROR_DATA.TOASTER_TYPES.INFO.id]) !== null && _managedExceptions$ER4 !== void 0 && _managedExceptions$ER4[code])) {
    message = managedExceptions[ERROR_DATA.TOASTER_TYPES.INFO.id][code];
    type = ERROR_DATA.TOASTER_TYPES.INFO.class;
  } else {
    message = defaultMessage !== null && defaultMessage !== void 0 ? defaultMessage : ERROR_DATA.TOASTER_TYPES.ERROR.defaultMessage;
    type = ERROR_DATA.TOASTER_TYPES.ERROR.class;
    if (isPriorityToApiMessage) {
      var _e$response2, _e$response3, _e$response4;
      if ((_e$response2 = e.response) !== null && _e$response2 !== void 0 && (_e$response2 = _e$response2.data) !== null && _e$response2 !== void 0 && (_e$response2 = _e$response2.value) !== null && _e$response2 !== void 0 && _e$response2.message) {
        message = e.response.data.value.message;
        type = ERROR_DATA.TOASTER_TYPES.WARNING.class;
      } else if ((_e$response3 = e.response) !== null && _e$response3 !== void 0 && (_e$response3 = _e$response3.data) !== null && _e$response3 !== void 0 && (_e$response3 = _e$response3.value) !== null && _e$response3 !== void 0 && _e$response3.Message) {
        message = e.response.data.value.Message;
        type = ERROR_DATA.TOASTER_TYPES.WARNING.class;
      } else if ((_e$response4 = e.response) !== null && _e$response4 !== void 0 && (_e$response4 = _e$response4.data) !== null && _e$response4 !== void 0 && _e$response4.value) {
        message = e.response.data.value;
        type = ERROR_DATA.TOASTER_TYPES.WARNING.class;
      }
    }
    if (typeof message !== "string") message = ERROR_DATA.TOASTER_TYPES.ERROR.messageIfCompleteExceptionConsole;
  }
  if (isPriorityToApiMessage && (_e$response5 = e.response) !== null && _e$response5 !== void 0 && (_e$response5 = _e$response5.data) !== null && _e$response5 !== void 0 && (_e$response5 = _e$response5.value) !== null && _e$response5 !== void 0 && _e$response5.message) {
    message = e.response.data.value.message;
  }
  if (typeof message !== "string" || ((_message = message) === null || _message === void 0 ? void 0 : _message.length) < 1) {
    message = ERROR_DATA.TOASTER_TYPES.ERROR.defaultMessage;
  }
  return {
    message: message,
    type: type,
    code: code,
    dialogType: dialogType
  };
}
export function handleErrorData(_this, errorData) {
  var dialogOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (errorData.dialogType === ERROR_DATA.DIALOG_TYPES.DIALOG_RELOAD.id) {
    _this.$refs[ERROR_DATA.ref].open(errorData.dialogType, errorData.message, dialogOptions);
  } else if (errorData.dialogType === ERROR_DATA.DIALOG_TYPES.DIALOG_WARNING.id) {
    _this.$refs[ERROR_DATA.ref].open(errorData.dialogType, errorData.message, dialogOptions);
  } else {
    _this.$toasted.show(errorData.message, {
      type: errorData.type
    });
  }
}
export function boolToInt(bool) {
  return +bool;
}
export function intToBool(int) {
  return +int > 0;
}
export function hackReactivityForm(_x, _x2, _x3, _x4) {
  return _hackReactivityForm.apply(this, arguments);
}

//METHOD TO EMPTY ERRORS ARRAY - TO DELETE ONE DAY
function _hackReactivityForm() {
  _hackReactivityForm = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_this, formObject, formProperty, refString) {
    var inputType,
      wrapper,
      element,
      originalValue,
      eventInput,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          inputType = _args.length > 4 && _args[4] !== undefined ? _args[4] : "input";
          wrapper = _this.$refs[refString];
          if (!(!wrapper || !wrapper.$el)) {
            _context.next = 5;
            break;
          }
          console.warn("hackReactiveForm: ref \"".concat(refString, "\" introuvable"));
          return _context.abrupt("return");
        case 5:
          element = wrapper.$el.querySelector(inputType);
          if (element) {
            _context.next = 9;
            break;
          }
          console.warn("hackReactiveForm: aucun <".concat(inputType, "> trouv\xE9 pour ref \"").concat(refString, "\""));
          return _context.abrupt("return");
        case 9:
          originalValue = formObject[formProperty] || "";
          eventInput = new Event("input", {
            bubbles: true
          });
          formObject[formProperty] = originalValue + " ";
          _context.next = 14;
          return _this.$nextTick();
        case 14:
          element.dispatchEvent(eventInput);
          _context.next = 17;
          return _this.$nextTick();
        case 17:
          formObject[formProperty] = originalValue;
          _context.next = 20;
          return _this.$nextTick();
        case 20:
          element.dispatchEvent(eventInput);
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _hackReactivityForm.apply(this, arguments);
}
export function cleanErrors(errorsArray) {
  for (var key in errorsArray) {
    errorsArray[key] = "";
  }
  return errorsArray;
}

//METHOD TO CHECK IF ERRORS ARRAY EMPTY OR NOT - TO DELETE ONE DAY
export function noErrors(errorsArray) {
  for (var key in errorsArray) {
    if (errorsArray[key] != "") return false;
  }
  return true;
}